module.exports = __webpack_public_path__ + "static/img/m3.565251e.png";


//////////////////
// WEBPACK FOOTER
// ./static/m3.png
// module id = iSg4
// module chunks = 1